import React from 'react'
import Navbar from '../components/Navbar'
import bg1 from '../assets/bg-leasingi.jpg'
import Footer from '../components/Footer'
import {dlaczego, zalety, rodzaje} from '../components/LeasingiItems'

function Leasingi() {
  return (
    <div>
    <Navbar />
    <div className='pt-20 flex justify-center mx-auto static'>
        <div className='bg-white bg-opacity-90 absolute mx-auto justify-center mt-20 max-w-[450px] text-center py-8 rounded-xl px-2'>
          <h3 className='uppercase text-xl md:text-3xl font-semibold pb-2'>Leasingi</h3>
          <p className='font-normal'>Leasing to najpopularniejsza forma finansowania wśród przedsiębiorców. Z pomocą naszego eksperta znajdziemy najlepsze rozwiązanie.</p>
        </div>
      <img src={bg1} alt="background photo" className='w-screen h-96 object-cover'/>
    </div>
    
    <div className='max-w-[1240px] bg-white mx-auto justify-center text-center'>
      <div className='pt-10'>
        <h3 className='text-xl md:text-3xl font-bold'>Dla czego warto wybrać naszego eksperta  :</h3>
        {dlaczego.map((item) => (
          <p key={item.id} className='pt-4 mx-20'>{item.text}</p>
        ))}
      </div>

      <div className='pt-10'>
        <h3 className='text-xl md:text-3xl font-bold'>Zalety leasingu</h3>
        <div className='pt-4 gap-3 grid md:grid-cols-3 px-20'>
          {zalety.map((item) => (
            <div key={item.id} className='px-5 pt-4'>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
      
      <div className='pt-10'>
        <h3 className='text-xl md:text-3xl font-bold'>Rodzaje umów leasingowych</h3>
        <div className='pt-4 gap-3 grid md:grid-cols-3 px-20'>
          {rodzaje.map((item) => (
            <div key={item.id} className='px-4 pt-4'>
              <h4 className='font-semibold text-lg md:text-xl'>{item.title}</h4>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
        
    <Footer />
    </div>  
    </div>
  )
}

export default Leasingi